module finadai.app.payYourCredit {
  export var NAME = 'finadai.app.payYourCredit';
  function PayYourCreditController($scope, customersService: services.CustomersService, $mdDialog,  $filter) {
    $scope.formData = {};
    $scope.message = null;
    $scope.customer_number = 0;
    $scope.userData = null;
    $scope.loading = false;
    $scope.submit = (form) => {
      if(form.$valid){
        $scope.loading = true;
        customersService.proxyNewSearch($scope.formData).then(response => {
          $scope.loading = false;
            const customer = <models.proxy.Customer>response.data.Data.Customer;

            let payment_text = `<p><strong>La información para realizar tu pago es: <br />
Numero de Cuenta HSBC*: 4051630465<br />
Servicio: 487<br />
Referencia: ${customer.ReferenciaHSBC}<br />
</strong></p>
<p>*Beneficiario <a target="_blank" href="http://www.quam.mx/preguntas.php#tertius">TERTIUS</a></p>`;
            if (angular.isArray(response.data.Data.Saldo)) {
            const saldos = <models.proxy.Saldo[]>response.data.Data.Saldo;
            let message = ``;
            saldos.forEach(s => {
              message+= `<p> Tipo de producto: ${s.TipoProducto} <br/>
                          Numero Tarjeta de Credito/Credito: ${s.CreditoId} <br />
                         <br /></p>`;
                $scope.customer_number = s.NumCliente;
            });
            $scope.message = { 
              type: 'success', 
              text: message,
              title: 'Amigo, el detalle de tus créditos es:',
              stub: payment_text
            }
          } else {
            const saldo = <models.proxy.Saldo>response.data.Data.Saldo;
            $scope.message = { 
              type: 'success', 
              text: ` <p>Tipo de producto: ${saldo.TipoProducto} <br/>
                       Numero Tarjeta de Credito/Credito: ${saldo.CreditoId} <br />
                      </p>`,
                title: 'Amigo, el detalle de tu crédito es:',
                stub: payment_text
            }
            $scope.customer_number = saldo.NumCliente;
          }
        }).catch(rejection => {
          $scope.loading = false;
          if (rejection.data.data && rejection.data.data.DetailedException) {
            $scope.message = { type: 'danger', text: rejection.data.data.DetailedException };
          } else {
            $scope.message = { type: 'danger', title: "No hemos encontrado detalle de algún crédito con la información que has proporcionado. Comunícate a través del chat para que podamos asesorarte." };
          }
        })
      }
    }

    $scope.showTerms = (ev) => {
      $mdDialog.show({
        templateUrl: 'app/layout/terms.tpl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: false // Only for -xs, -sm breakpoints.
      });
    }
  }
  export function run(){
    var payYourCredit = angular.module(NAME, []);
    payYourCredit.controller('PayYourCreditController', PayYourCreditController)
  }
} finadai.app.payYourCredit.run();